module.exports = __webpack_public_path__ + "static/media/right.f46f4355.png";